import React from 'react';
import classNames from 'classnames';
import './index.less';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PREFIX = 'icloud-ui-state-tag';

const StateTag = ({
  children,
  className,
  type,
  style = {},
  iconStyle = {},
  ...props
}) => {
  return /*#__PURE__*/_jsxs("span", {
    className: classNames(PREFIX, className),
    style: style,
    ...props,
    children: [/*#__PURE__*/_jsx("i", {
      className: classNames(`${PREFIX}-prefix`, `${PREFIX}-${type}`),
      style: iconStyle
    }), /*#__PURE__*/_jsx("span", {
      children: children
    })]
  });
};

export default StateTag;
//# sourceMappingURL=es/index.js.map